import React, { Component } from "react";
import { Overlay } from "../Overlay/Overlay";
import { Button } from "@chakra-ui/react";
import APIService from "../Services/APIService";
import {CommonMethodService} from "../Services/CommonMethodService";
import { ForgotPasswordRequest } from "../modals/ForgotPasswordRequest";
require("./forgotPassword.css");

export interface Props {
  closeModal: () => void;
}
export interface State {
  email: string;
  isSent: boolean;
}

export default class ForgotPassword extends Component<Props, State> {
  private apiService: APIService;
  constructor(props: any) {
    super(props);
    this.state = {
      email: "",
      isSent: false
    };
    this.apiService = new APIService();
  }

  isValidEmail(email: string) {
    if (!email) {
      return true;
    }

    return /\S+@\S+\.\S+/.test(email);
  }

  async forgotPassword() {
    const params = CommonMethodService.params();
    const forgotPasswordPayload: ForgotPasswordRequest = {
      email: this.state.email,
      estimateId: params.estimateid
    };

    await this.apiService.forgotPassword(forgotPasswordPayload);

    this.setState({ isSent: true });

    setTimeout(() => {
      this.props.closeModal();
    }, 5000);
  }

  render() {
    return (
      <div className="forgot-password-dialog-container">
        <Overlay
          isMenuOverlay={true}
          closeModal={this.props.closeModal}
        ></Overlay>
        <div className={"container-forgot container"}>
          <div className={"title-forgot"}>Forgot Password</div>
          {!this.state.isSent && (
            <div className={"messageTextContainer"}>
              Enter your email address and we’ll send you a link to reset you
              password.
            </div>
          )}
          {!this.state.isSent && (
            <>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  this.forgotPassword();
                }}
              >
                <div className="input-wrapper">
                  <input
                    className={[
                      "input-forgot",
                      this.isValidEmail(this.state.email) ? "" : "invalid-email"
                    ].join(" ")}
                    placeholder="Email address"
                    value={this.state.email}
                    onChange={(e) => {
                      this.setState({ email: e.currentTarget.value });
                    }}
                    type="email"
                    required
                  />
                  {this.isValidEmail(this.state.email) ? (
                    <></>
                  ) : (
                    <span className="invalid-email">Invalid email</span>
                  )}
                </div>
                <div className="button-forgot">
                  <Button
                    style={{ width: "100%" }}
                    colorScheme={"blue"}
                    variant={"solid"}
                    disabled={
                      !this.state.email || !this.isValidEmail(this.state.email)
                    }
                    onClick={() => this.forgotPassword()}
                  >
                    RESET PASSWORD
                  </Button>
                </div>
              </form>
              <p className="small-text" onClick={() => this.props.closeModal()}>
                Log in to Customer Portal
              </p>
            </>
          )}
          {this.state.isSent && (
            <div className={"messageTextContainer"}>
              We’ve sent you an email with a link to reset your password.
            </div>
          )}
        </div>
      </div>
    );
  }
}
